var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cor_detail"
  }, [_c('h3', [_vm._v($t("obrz2", "详情"))]), _c('div', {
    staticClass: "action"
  }, [_c('Button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v($t("oxvu2", "返回"))])], 1), _vm._m(0), _c('Divider'), _c('div', {
    staticClass: "invitation"
  }, [_c('span', [_vm._v($t("ug227p6", "邀请企业加入"))]), _c('span', {
    staticClass: "qr"
  }, [_c('canvas', {
    attrs: {
      "id": "qrcode_corpcircle_canvas"
    }
  }), _c('span', [_c('div', [_vm._v($t("878p4tl", "一个二维码只能被一个企业加入，24小时有效"))]), _c('div', [_c('a', {
    on: {
      "click": _vm.copy
    }
  }, [_vm._v($t("ht87mh6", "复制邀请链接"))]), _vm._v(" | "), _c('a', {
    on: {
      "click": _vm.resetQr
    }
  }, [_vm._v($t("fqzejw7", "生成新的二维码"))])])])])]), _c('Divider'), _vm._m(1), _c('Divider'), _c('div', {
    staticClass: "remove"
  }, [_c('div', {
    staticClass: "remove_text"
  }, [_vm._v($t("i0itmx4", "解除关系"))]), _c('div', {
    staticClass: "remove_content"
  }, [_c('Button', {
    on: {
      "click": function ($event) {
        return _vm.openModal('remove');
      }
    }
  }, [_vm._v($t("oeehik8", "解除所有互联关系"))]), _c('div', {
    staticClass: "remove_content_remark"
  }, [_vm._v(` ${$t("6rid2fz", "解除所有互联关系后，该范围内的所有企业将无法看到互联人员，请谨慎操作。")} `)])], 1)]), _c('Remove', {
    attrs: {
      "visible": _vm.remove.visible
    },
    on: {
      "close": function ($event) {
        _vm.remove.visible = false;
      }
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "base"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v($t("hulwc37", "绿云的互联企业"))]), _c('div', {
    staticClass: "message"
  }, [_vm._v($t("o26zven", "在同一范围内的互联企业成员可能互相进行工作沟通"))]), _c('div', {
    staticClass: "message"
  }, [_vm._v($t("yb5aesn", "互联ID：wh10aeoa7c62ec2753"))])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "has_join"
  }, [_c('div', {
    staticClass: "has_join_text"
  }, [_vm._v($t("mxkt685", "已加入企业"))]), _c('div', {
    staticClass: "has_join_item"
  }, [_c('div', {
    staticClass: "has_join_enterprise"
  }, [_c('span', {
    staticClass: "hse_name"
  }, [_vm._v($t("m16a2", "绿云"))]), _c('span', {
    staticClass: "hse_ID"
  }, [_vm._v("Corp ID：wh10aeoa4c62ec2236")])]), _c('div', {
    staticClass: "has_join_enterprise"
  }, [_c('span', {
    staticClass: "hse_name"
  }, [_vm._v($t("iz0g03", "绿云2"))]), _c('span', {
    staticClass: "hse_ID"
  }, [_vm._v("Corp ID：wh10aeoa4c62ec2679")])])])]);
}];
export { render, staticRenderFns };